import { render, staticRenderFns } from "./coupon_list.vue?vue&type=template&id=c154d64e&scoped=true&"
import script from "./coupon_list.js?vue&type=script&lang=js&"
export * from "./coupon_list.js?vue&type=script&lang=js&"
import style0 from "./coupon_list.css?vue&type=style&index=0&id=c154d64e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c154d64e",
  null
  
)

export default component.exports